import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onChange = object(listener, {
  type: input,
  passive,
  task: (select) => {
    const { ownerDocument } = select
    ownerDocument.documentElement.dataset.theme = select.options[select.selectedIndex].value
  }
})

export default select => {
  onChange.listen(select)
}